export enum TemperatureByVehicleColumn {
  Date = 'occurredAt',
  SensorID = 'sensorId',
  Label = 'label',
  RegNo = 'vehicleRegNo',
  Temperature = 'temperature',
  Humidity = 'humidity',
  LightStatus = 'ambientLightStatus',
  Position = 'position',
}
